var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 72,
    fill: "#F2A6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.974 43.2211C99.8037 42.229 97.966 42.087 96.066 42.8498H96.0628C94.0645 43.6517 39.4957 67.0579 37.2742 68.0142C36.8702 68.1546 33.3415 69.4712 33.705 72.404C34.0294 75.0482 36.8655 76.1434 37.2118 76.2697L51.0849 81.0199C52.0053 84.0838 55.3983 95.3875 56.1487 97.8024C56.6167 99.3078 57.3795 101.286 58.7164 101.693C59.8896 102.145 61.0564 101.732 61.8115 101.139L70.2932 93.2722L83.9853 103.95L84.3114 104.145C85.2411 104.557 86.1319 104.763 86.9821 104.763C87.6388 104.763 88.2691 104.64 88.8712 104.393C90.9226 103.551 91.7432 101.596 91.829 101.375L102.056 48.2147C102.68 45.3755 101.813 43.9309 100.974 43.2211ZM63.32 82.92L58.64 95.4L53.96 79.8L89.84 53.28L63.32 82.92Z",
    fill: "#F5F0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg_logo.17ddd943e4e43dfe5694ed82d5b84fb8.svg";
export { ForwardRef as ReactComponent };